import { createFileRoute, Navigate } from "@tanstack/react-router";

import { useUserSettings } from "#app/lib/hooks/use-user-settings";
import { getDefaultRouteSuffix } from "#app/lib/default-route";
import { PageLoading } from "#app/components/loading/page-loading";
import { routePath } from "#app/lib/hooks/use-app-navigate";

/**
 * Workspace landing. The widget surfaces own analytics, so the root renders no
 * content of its own — it redirects to the user's chosen landing route
 * (`preferences.defaultRoute`, default My Work). The suffix is
 * workspace-relative and every option is non-empty, so the redirect always
 * leaves the root.
 *
 * Preferences load async. Hold on a spinner for the first fetch so a user with
 * a non-default landing route is not bounced to My Work and then again to
 * their real choice.
 */
function Index() {
  const { preferences, isLoading } = useUserSettings();

  if (isLoading && !preferences) {
    return <PageLoading delayed />;
  }

  const suffix = getDefaultRouteSuffix(preferences?.defaultRoute);
  // Absolute `to` with the `$workspace` param inherited from the current
  // match (same idiom as workflow/index.tsx's Navigate).
  return <Navigate to={routePath(`/$workspace${suffix}`)} replace />;
}

export const Route = createFileRoute("/(app)/$workspace/")({
  component: Index,
});
